"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var MountReactComponent_1 = require("MountReactComponent/MountReactComponent");
var quoteSectionSelection_1 = __importDefault(require("QuoteV2/View/quoteSectionSelection"));
var deselectSectionUtls_1 = require("../Common/deselectSectionUtls");
var Quote_1 = __importDefault(require("QuoteV2/Components/Quote"));
var QuoteBlockStore_1 = __importDefault(require("QuoteV2/Stores/QuoteBlockStore"));
var CalculatorService_1 = __importDefault(require("QuoteV2/Calculator/CalculatorService"));
var UniqueId_1 = __importDefault(require("@CommonFrontendBackend/Utils/UniqueId"));
var QuoteComponents_1 = require("QuoteV2/Components/QuoteComponents");
var TaxService_1 = __importDefault(require("QuoteV2/TaxService"));
var QwilrEditorComponent_1 = __importDefault(require("Project/QwilrEditor/QwilrEditorComponent"));
var QuoteTelemetry_1 = require("Telemetry/QuoteTelemetry");
var DiscountEditor_1 = require("./SettingsMenus/DiscountEditor/DiscountEditor");
var SectionFooter_1 = __importDefault(require("./ClientComponents/SectionFooter"));
var SectionMenu_1 = __importDefault(require("./ClientComponents/SectionMenu"));
var partiallyApplyComponent_1 = __importDefault(require("QuoteV2/Components/partiallyApplyComponent"));
var TotalMenu_1 = __importDefault(require("./ClientComponents/TotalMenu"));
var ItemAddMenu_1 = __importDefault(require("./ClientComponents/ItemAddMenu"));
var SectionAddButton_1 = __importDefault(require("./ClientComponents/SectionAddButton"));
var ItemRate_1 = __importDefault(require("./ClientComponents/ItemRate"));
var ItemQuantity_1 = __importDefault(require("./ClientComponents/ItemQuantity"));
var ItemMenu_1 = __importDefault(require("./ClientComponents/ItemMenu"));
var QuoteLabelStore_1 = __importDefault(require("QuoteV2/Labels/QuoteLabelStore"));
var SectionToolbar_1 = __importDefault(require("./ClientComponents/SectionToolbar"));
var VariableStore_1 = __importDefault(require("QuoteV2/Stores/VariableStore"));
var QuoteViewStore_1 = require("QuoteV2/Stores/QuoteViewStore");
var ColumnVisibilityButton_1 = __importDefault(require("./ClientComponents/ColumnVisibilityButton"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var TelemetryEnums_1 = require("Telemetry/TelemetryEnums");
var DIProvider_1 = __importDefault(require("DIProvider/DIProvider"));
var inversify_1 = require("inversify");
var AngularSyncStore_1 = require("Utils/AngularSyncStore");
var PlanCardMenu_1 = __importDefault(require("./ClientComponents/PlanCardMenu"));
var PlanCardPricePopover_1 = __importDefault(require("./ClientComponents/PlanCardPricePopover"));
var PlanCardAddMenu_1 = __importDefault(require("./ClientComponents/PlanCardAddMenu"));
var PlanSectionOptionsMenu_1 = __importDefault(require("./ClientComponents/PlanSectionOptionsMenu"));
var PlanSectionAddGroupMenu_1 = __importDefault(require("./ClientComponents/PlanSectionAddGroupMenu"));
var PlanSectionEditGroupMenu_1 = __importDefault(require("./ClientComponents/PlanSectionEditGroupMenu"));
var EditorQuoteViewStore_1 = require("./EditorQuoteViewStore");
var QuoteProductStore_1 = require("./QuoteProductStore/QuoteProductStore");
var QuoteProductContext_1 = require("./ItemComponents/QuoteProductContext");
var QuoteProductFilter_1 = __importDefault(require("./ClientComponents/QuoteProductFilter"));
var DragDropHandler_1 = __importDefault(require("./ClientComponents/DragDropHandler"));
var DiscountNotice_1 = __importDefault(require("./ClientComponents/DiscountNotice"));
var QuoteV2Block = (function () {
    function QuoteV2Block(block, make, createUi, Editor, viewState, quoteContent, di, usingFeature, modal, $timeout) {
        var e_1, _a, e_2, _b;
        try {
            for (var _c = __values(block.sections), _d = _c.next(); !_d.done; _d = _c.next()) {
                var section = _d.value;
                section.$id = (0, UniqueId_1.default)();
                try {
                    for (var _e = (e_2 = void 0, __values(section.items)), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        item.$id = (0, UniqueId_1.default)();
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var headerContent = make(Editor, {
            model: block.contentAreas.header,
            options: {},
            configuration: "standard",
        });
        var QuoteEditor = function (_a) {
            var content = _a.content, configuration = _a.configuration;
            var key = react_1.default.useMemo(function () { return (0, UniqueId_1.default)(); }, [content]);
            return (react_1.default.createElement(QwilrEditorComponent_1.default, { key: key, di: di, model: content, configuration: configuration, usingFeature: usingFeature, block: block, modal: modal }));
        };
        var createReactQuoteBlock = function ($scope) {
            var accountQuoteSettings = di.get("accountQuoteSettings");
            var telemetry = di.get("telemetry");
            var blockStore = di.get("blockStore");
            var billingScheduleOrchestrator = di.get("billingScheduleOrchestrator");
            var quoteProductStore = di.make(QuoteProductStore_1.QuoteProductStore);
            var MaybeOverlayProvider = function (_a) {
                var children = _a.children;
                return blockStore.isSavedBlock ? react_1.default.createElement(kaleidoscope_1.AngularOverlayProvider, null, children) : children;
            };
            return (0, MountReactComponent_1.mountReactComponent)(createUi, di)(react_1.default.createElement(MaybeOverlayProvider, null,
                react_1.default.createElement(DIProvider_1.default, { container: function () {
                        var container = new inversify_1.Container({ skipBaseClassChecks: true });
                        container.bind(TaxService_1.default).toConstantValue(new TaxService_1.default(accountQuoteSettings.taxes));
                        container.bind(AngularSyncStore_1.AngularSyncServices.$).toConstantValue({ $scope: $scope, $timeout: $timeout });
                        container.bind(QuoteViewStore_1.QuoteViewStore.$).to(EditorQuoteViewStore_1.EditorQuoteViewStore).inSingletonScope();
                        container.bind(QuoteBlockStore_1.default).toSelf().inSingletonScope();
                        container.bind(CalculatorService_1.default).toSelf().inSingletonScope();
                        container.bind(QuoteTelemetry_1.QuoteTelemetry).toConstantValue(new QuoteTelemetry_1.QuoteTelemetry(function (eventName, properties) { return telemetry.trackOnly(eventName, properties, { blockIntercom: true }); }, function (eventName, properties) {
                            return telemetry.debouncedTrack(eventName, properties, { blockIntercom: true }, 500);
                        }, TelemetryEnums_1.TelemetryContext.Client, billingScheduleOrchestrator));
                        container.bind(DiscountEditor_1.DiscountEditor).toConstantValue(make(DiscountEditor_1.DiscountEditor, { onDiscountUpdated: console.log }));
                        container.bind(VariableStore_1.default).toSelf().inSingletonScope();
                        container.bind(QuoteLabelStore_1.default).toSelf().inSingletonScope();
                        container.bind(QuoteComponents_1.QuoteComponents.$).toConstantValue({
                            SectionDescription: (0, partiallyApplyComponent_1.default)(QuoteEditor, { configuration: "quote" }),
                            SectionMenu: SectionMenu_1.default,
                            SectionFooter: SectionFooter_1.default,
                            SectionAddButton: SectionAddButton_1.default,
                            TableItemDescription: (0, partiallyApplyComponent_1.default)(QuoteEditor, { configuration: "quoteLineItem" }),
                            ItemRate: ItemRate_1.default,
                            ItemQuantity: ItemQuantity_1.default,
                            DiscountNotice: DiscountNotice_1.default,
                            ItemMenu: ItemMenu_1.default,
                            ItemAddMenu: ItemAddMenu_1.default,
                            PlanCardDescription: (0, partiallyApplyComponent_1.default)(QuoteEditor, { configuration: "quotePlanCard" }),
                            PlanCardFeatureList: (0, partiallyApplyComponent_1.default)(QuoteEditor, {
                                configuration: "quotePlanCardFeatureList",
                            }),
                            PlanCardMenu: PlanCardMenu_1.default,
                            PlanCardAddMenu: PlanCardAddMenu_1.default,
                            PlanCardPricePopover: PlanCardPricePopover_1.default,
                            TotalMenu: TotalMenu_1.default,
                            SectionToolbar: SectionToolbar_1.default,
                            ColumnVisibilityButton: ColumnVisibilityButton_1.default,
                            PlanSectionOptionsMenu: PlanSectionOptionsMenu_1.default,
                            PlanSectionAddGroupMenu: PlanSectionAddGroupMenu_1.default,
                            PlanSectionEditGroupMenu: PlanSectionEditGroupMenu_1.default,
                            QuoteProductContext: QuoteProductContext_1.QuoteProductContext,
                            QuoteProductFilter: QuoteProductFilter_1.default,
                            DragDropHandler: DragDropHandler_1.default,
                        });
                        container.bind(QuoteProductStore_1.QuoteProductStore).toConstantValue(quoteProductStore);
                        return container;
                    } },
                    react_1.default.createElement(Quote_1.default, { className: "qwilr-quote-v2-react" }))), {
                onDestroy: function () {
                    quoteProductStore.unbind();
                },
            });
        };
        this.ui = createUi(require("./QuoteV2.html"), {
            viewState: viewState,
            headerContent: headerContent.ui,
            quoteContent: quoteContent.ui,
            $init: function ($scope) {
                $scope.ui.reactQuoteContent = createReactQuoteBlock($scope);
            },
            deselectQuoteSection: function (e) {
                if ((0, deselectSectionUtls_1.hasDeselectElementClicked)(e.target)) {
                    return (quoteSectionSelection_1.default.activeSectionId = null);
                }
            },
        });
    }
    return QuoteV2Block;
}());
exports.default = QuoteV2Block;
